import { createSlice } from '@reduxjs/toolkit'
import { I18n } from 'i18n-js'

const reducer = createSlice({
  name: 'local',
  initialState: {
    refreshKey: 0,
    navItem: 'preview',
    selectedActionId: null,
    selectedQuestionId: null,
    selectedPageNumber: 1,
    loaded: false,
    modal: {
      kind: null
    },
    isDirty: false,
    errors: {},
    language: null,
  },
  reducers: {
    set: (s, a) => a.payload,
    upsert: (s, a) => ({ ...s, ...a.payload }),
    // Clear a single key from local.errors
    clearErrors: (s, a) => {
      if (!a.payload) return
      if (a.payload[a.payload] === undefined) return
      delete s.errors[a.payload]
    }
  },
}).reducer

const actions = (dis, store, restClient) => {
  return {
    set: (payload) => {
      dis({ type: 'local/set', payload })
    },
    upsert: (payload) => {
      dis({ type: 'local/upsert', payload })
    },
    setNav: (navItem) => {
      dis({ type: 'local/upsert', payload: { navItem: navItem } })
    },
    setModal: (modal) => {
      dis({ type: 'local/upsert', payload: { modal } })
    },
    setDirty: (isDirty) => {
      dis({ type: 'local/upsert', payload: { isDirty } })
    },
    closeModal: () => {
      dis({ type: 'local/upsert', payload: { modal: { kind: null } } })
    },
    setLanguage: (language) => {
      dis({ type: 'local/upsert', payload: { language } })
    }
  }
}

export { reducer, actions }
export default { reducer, actions }
